import { common } from '@constants';

export const getItemSizes = (itemId, items, sizes) => (
  itemId && items[itemId]
    ? items[itemId].sizeIds.map(sizeId => ({
      name: sizes[sizeId].name,
      price: sizes[sizeId].price,
      id: parseInt(sizeId, 10),
    }))
    : []
);

export const getSizeOptions = (sizeId, options, sizes) => (
  sizeId && sizes[sizeId]
    ? sizes[sizeId].optionIds.map(optionId => ({
      name: options[optionId].name,
      id: parseInt(optionId, 10),
    }))
    : []
);

export const getOptionValues = (optionId, options, optionValues) => (
  optionId && options[optionId]
    ? options[optionId].valueIds.map(valueId => ({
      name: optionValues[valueId].name,
      id: parseInt(valueId, 10),
    }))
    : []
);

// Checking if value from input is valid (If number, if value > 0, if number of digits after dot < 3)
export const isPriceValid = price => common.PRICE_REGEX.test(price) || !price;

// Formating tip value for input
export const formatPrice = price => (price.includes('.') && price.slice(0, 1) !== '.' ? price : Number(price));

export const getAllOptionsExceptCurrentSizeOptions = (options, sizes, items, optionValues, sizeId) => {
  const itemNamesByOptionId = {};

  Object.keys(items).forEach(itemId => items[itemId].sizeIds.forEach(
    itemSizeId => {
      // don't include options for current size
      if (itemSizeId === sizeId) return;
      sizes[itemSizeId].optionIds.forEach(
        optionId => {
          itemNamesByOptionId[optionId] = itemNamesByOptionId[optionId]
            ? itemNamesByOptionId[optionId] += `, ${items[itemId].name}`
            : items[itemId].name;
        },
      );
    },
  ));

  const optionIdsToSkip = sizes[sizeId].optionIds;

  return Object.keys(options).reduce(
    (acc, optionId) => {
      // don't include options for current size
      if (!optionIdsToSkip.includes(+optionId)) {
        acc.push({
          id: +optionId,
          name: options[optionId].name,
          optionValues: options[optionId].valueIds.map(valueId => ({
            id: +valueId,
            name: optionValues[valueId].name,
            price: optionValues[valueId].price,
          })),
          optionItemNames: itemNamesByOptionId[optionId] ?? '',
        });
      }

      return acc;
    },
    [],
  );
};

export const getAllAvailabilitiesExceptApplied = (availabilities, appliedAvailabilities) => (
  Object.keys(availabilities).reduce((acc, id) => {
    if (!appliedAvailabilities.includes(parseInt(id, 10))) {
      acc.push({
        id: parseInt(id, 10),
        name: availabilities[id].name,
      });
    }

    return acc;
  }, []));

export const getItemSpecials = (specialsSize, items, itemId, sizes) => (
  items[itemId]?.sizeIds.flatMap(sizeId => (
    sizes[sizeId].specialIds.map(specialId => ({
      id: specialId,
      sizeName: sizes[sizeId].name,
      ...specialsSize[specialId],
    }))
  ))
);

